module.exports = "/_next/static/images/slide5-bb24123fa75f0c37635627a94780ab1c.jpg.webp";